import { render } from "./Conversation.vue?vue&type=template&id=6bccf4d8&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=6bccf4d8&scoped=true&lang=css"
import "./Conversation.vue?vue&type=style&index=1&id=6bccf4d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bccf4d8"]])

export default __exports__